import { replaceInChain } from "@insite/client-framework/HandlerCreator";
import { chain, SendActivationEmail } from "@insite/client-framework/Store/Pages/UserList/Handlers/CreateUser";
import { getIsExternalLogin } from "@store/Store/Context/ContextSelectors";

replaceInChain(chain, SendActivationEmail, props => {
	/* Poolcorp Custom Code */
    const isExternalLogin = getIsExternalLogin(props.getState());
	
	if (!isExternalLogin) {
		SendActivationEmail(props);
	}
	/* Poolcorp Custom Code */
});
